export default class Martyr
{
    constructor(sacrificer_code, personal_info, istshhad_info, loan_info, attachment_info){
        this.sacrificer_code = sacrificer_code
        this.personal_info = personal_info
        this.istshhad_info = istshhad_info
        this.loan_info = loan_info
        this.attachment_info = attachment_info
    }

    toFormData(){
        let fData = new FormData()
        
        //personal information for injury.
        // fData.append('name1', this.personal_info.name1);
        // fData.append('name2', this.personal_info.name2);
        // fData.append('name3', this.personal_info.name3);
        // fData.append('name4', this.personal_info.name4);
        // fData.append('family_name', this.personal_info.family_name);
        // fData.append('mother_name', this.personal_info.mother_name);

        fData.append('sacrificer_code', this.sacrificer_code);
        fData.append('birth_date', this.personal_info.birth_date);
        fData.append('phone1', this.personal_info.phone1);
        fData.append('phone2', this.personal_info.phone2);    
        fData.append('marital_status_id', this.personal_info.marital_status_id);
        fData.append('certificate_id', this.personal_info.certificate_id);
        fData.append('number_children', this.personal_info.number_children);
        fData.append('religion_id', this.personal_info.religion_id);
        fData.append('nationalism_id', this.personal_info.nationalism_id);
        fData.append('denomination_id', this.personal_info.denomination_id);
        fData.append('father_alive', this.personal_info.father_alive);
        fData.append('mother_alive', this.personal_info.mother_alive);
        fData.append('retirement_number', this.personal_info.retirement_number);

        //injury info.
        fData.append('date_marty', this.istshhad_info.date_marty);
        fData.append('place_marty', this.istshhad_info.place_marty);
        fData.append('dept', this.istshhad_info.dept);

        //loan
        fData.append('grant_name', this.loan_info.grant_name);
        fData.append('borrower_name', this.loan_info.borrower_name);
        fData.append('received_date', this.loan_info.received_date);
        fData.append('amount', this.loan_info.amount);
        fData.append('amount_paid', this.loan_info.amount_paid);
        fData.append('amount_remaining', this.loan_info.amount_remaining);
        fData.append('bank_type_id', this.loan_info.bank_type_id);
        
        //attachment info.
        fData.append('attachment_basic', this.attachment_info.attachment_basic);
        if(typeof this.attachment_info.attachment_info == 'object')
            fData.append('attachment_info', this.attachment_info.attachment_info);
        fData.append('attachment_loan', this.attachment_info.attachment_loan);

        return fData
    }
}

